import {Row} from "antd";
import React from "react";
const HeaderCustom = ({title}) => {
  return (
    <Row
      style={{
        padding: "5px ",
        backgroundColor: "#f0f0f0",
        fontWeight: "600",
      }}
      justify={"center"}
      align={"middle"}
    >
      {title}
    </Row>
  );
};
export default HeaderCustom;
